<template>
  <div>

    <ContentHome ref="contentHome"></ContentHome>

  </div>
</template>

<script>

import ContentHome from "@/views/rotary/contentHome";
export default {
  components: {ContentHome},
  //name: "contentEdit",
  // props: [""],
  data: function () {
    return {
      id: "",
    };
  },
  methods: {

  },
  mounted() {
    this.$refs.contentHome.loadData("");
  },
}
</script>


<style scoped>
/*.btn{*/
/*  color: white !important;*/
/*  width: 200px;*/
/*  height: 80px;*/
/*  margin: 10px;*/
/*}*/
</style>
